export const CSP_DIRECTIVES = [
    // script-src is deliberately absent: Salesforce removed it from CSP Trusted
    // Sites (Winter '24), and sending isApplicableToScriptSrc now fails the
    // whole deploy with "invalid at this location in type CspTrustedSite".
    // The order below matches the CspTrustedSite metadata type's declared
    // element sequence, which the SOAP schema enforces.
    { label: 'connect-src', metadataField: 'isApplicableToConnectSrc' },
    { label: 'font-src', metadataField: 'isApplicableToFontSrc' },
    { label: 'frame-src', metadataField: 'isApplicableToFrameSrc' },
    { label: 'img-src', metadataField: 'isApplicableToImgSrc' },
    { label: 'media-src', metadataField: 'isApplicableToMediaSrc' },
    { label: 'style-src', metadataField: 'isApplicableToStyleSrc' },
];
/**
 * Browser permissions granted alongside the directives. The softphone cannot
 * capture audio without the microphone permission, so it is requested for every
 * RocketPhone trusted site rather than only the app origin.
 */
export const CSP_PERMISSIONS = [
    { label: 'Microphone', metadataField: 'permissionsMicrophone' },
    { label: 'Camera', metadataField: 'permissionsCamera' },
];
/** Every directive field set to true, for metadata-based creation. */
export function allDirectivesEnabled() {
    const enabled = {};
    for (const directive of CSP_DIRECTIVES)
        enabled[directive.metadataField] = true;
    for (const permission of CSP_PERMISSIONS)
        enabled[permission.metadataField] = true;
    return enabled;
}
//# sourceMappingURL=csp.js.map